//
//
// lang.js
//
// author: marcio.garcia@newsoftware.com.br
//

export const msg = {

    txtTitle: "New Software",

    txtSlogan1: "O software que você procura não existe?",
    txtSlogan2: "Nós criamos para você.",
    btnSiteMap: "Site Map",
    btnContact: "Contact",
    txtSearch: "Search..",

    txtCopyright: "Copyright © 1996 - 2018 New Software. All rights reserved.",
    txtPrivacyPolicy: "Privacy Policy",
    txTermsConditions: "Terms of Use"


  
 


};
